/**
 * Compute fixed positioning for a chart popover anchored below a DOMRect.
 * Keeps the popover within the viewport horizontally; flips above if no room below.
 */

export const CHART_POPOVER_MARGIN = 8;
export const CHART_POPOVER_DEFAULT_WIDTH = 280;

export function computeChartPopoverPosition(
  anchor: DOMRectReadOnly,
  popoverWidth: number,
  popoverHeight: number,
  viewportWidth: number,
  viewportHeight: number,
): { top: number; left: number; placement: 'below' | 'above' } {
  const centerX = anchor.left + anchor.width / 2;
  let left = centerX - popoverWidth / 2;
  left = Math.max(CHART_POPOVER_MARGIN, Math.min(left, viewportWidth - popoverWidth - CHART_POPOVER_MARGIN));

  const spaceBelow = viewportHeight - anchor.bottom - CHART_POPOVER_MARGIN;
  const spaceAbove = anchor.top - CHART_POPOVER_MARGIN;
  const preferBelow = spaceBelow >= popoverHeight || spaceBelow >= spaceAbove;

  let top: number;
  let placement: 'below' | 'above';
  if (preferBelow) {
    top = anchor.bottom + CHART_POPOVER_MARGIN;
    placement = 'below';
    if (top + popoverHeight > viewportHeight - CHART_POPOVER_MARGIN && spaceAbove > spaceBelow) {
      top = anchor.top - popoverHeight - CHART_POPOVER_MARGIN;
      placement = 'above';
    }
  } else {
    top = anchor.top - popoverHeight - CHART_POPOVER_MARGIN;
    placement = 'above';
    if (top < CHART_POPOVER_MARGIN) {
      top = anchor.bottom + CHART_POPOVER_MARGIN;
      placement = 'below';
    }
  }

  top = Math.max(CHART_POPOVER_MARGIN, Math.min(top, viewportHeight - popoverHeight - CHART_POPOVER_MARGIN));

  return { top, left, placement };
}
